import SignUpSuccessModal from "./SignUpSuccessModal";

export default SignUpSuccessModal;
